<!-- @/components/AuditTable.vue -->
<template>
    <div class="audit-content">
        <!-- 加载状态 -->
        <div v-if="loading" class="loading" style="padding: 20px; text-align: center; color: #999;">
            <i class="el-icon-loading"></i> 正在加载审核规则...
        </div>

        <!-- 审核规则表格 -->
        <el-table v-else :data="tableData" border style="width: 100%" size="small">
            <el-table-column prop="index"  type="index" label="序号" width="60" align="center"></el-table-column>
            <el-table-column prop="ruleName" label="规则名"></el-table-column>
            <el-table-column prop="ruleDescription" label="规则描述"></el-table-column>
            <el-table-column prop="auditDetails" label="审核详情">
                <template slot-scope="scope">
                    <div class="audit-details-container">
                        <div
                            v-for="(line, index) in formatAuditDetails(scope.row.auditDetails)"
                            :key="index"
                            class="detail-line"
                            :class="getDetailLineClass(line)"
                        >
                            <span class="detail-content">{{ line }}</span>
                        </div>
                    </div>
                </template>


            </el-table-column>
            <el-table-column label="审核结果" width="100" align="center">
                <template slot-scope="scope">
                    <el-tag
                        v-if="scope.row.auditResult === 1"
                        type="success"
                        size="mini"
                    >
                        审核通过
                    </el-tag>
                    <el-tag
                        v-else-if="scope.row.auditResult === 2"
                        type="danger"
                        size="mini"
                    >
                        审核失败
                    </el-tag>
                    <el-tag
                        v-else-if="scope.row.auditResult === 0"
                        type="warning"
                        size="mini"
                    >
                        待审核
                    </el-tag>
                    <el-tag
                        v-else-if="scope.row.auditResult === 3"
                        type="info"
                        size="mini"
                    >
                        未接入
                    </el-tag>
                    <span v-else>
                         <el-tag
                             type="info"
                             size="mini"
                         >
                        未接入
                    </el-tag>
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="100" align="center">
                <template slot-scope="scope">
<!--                    <el-button type="text" @click="handleView(scope.row)">查看</el-button>-->
                    <el-button type="text" v-if="scope.row.auditResult==1 || scope.row.auditResult==2" @click="handleEdit(scope.row)">查看</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 空数据状态 -->
        <div v-if="!loading && tableData.length === 0" style="text-align: center; color: #999; padding: 20px;">
            暂无审核规则数据
        </div>

<!--        &lt;!&ndash; 最终审核结果 &ndash;&gt;-->
<!--        <div class="final-result" style="margin: 20px 0;">-->
<!--            <span>最终审核结果：</span>-->
<!--            <el-tag type="danger" size="medium">{{ finalResult }}</el-tag>-->
<!--        </div>-->

<!--        &lt;!&ndash; 备注输入框 &ndash;&gt;-->
<!--        <el-form :model="form" style="width: 100%;">-->
<!--            <el-form-item label="" label-width="0px">-->
<!--                <el-input-->
<!--                    disabled-->
<!--                    type="textarea"-->
<!--                    :rows="3"-->
<!--                    v-model="form.remarks"-->
<!--                ></el-input>-->
<!--            </el-form-item>-->
<!--        </el-form>-->

<!--        &lt;!&ndash; 操作按钮 &ndash;&gt;-->
<!--        <div class="dialog-footer" style="text-align: right; margin-top: 10px;">-->
<!--            <el-button size="small" @click="$emit('cancel')">取 消</el-button>-->
<!--            <el-button size="small" type="primary" @click="$emit('confirm', form.remarks)">确 定</el-button>-->
<!--        </div>-->



        <SignCheckDialog ref="signCheckDialog"></SignCheckDialog>


    </div>
</template>

<script>
// 假设你已全局配置了 axios，例如：Vue.prototype.$http = axios
// 或使用 import axios from 'axios'
import {getAuditRules} from '@/request/api';
import SignCheckDialog from "@/components/SignCheckDialog/SignCheckDialog.vue";
export default {
    name: 'AuditTable',
    components: {SignCheckDialog},
    props: {
        // 接收 folderId
        folderId: {
            type: [String, Number],
            required: true
        }
    },
    data() {
        return {

            loading: false,
            tableData: [],
            form: {
                remarks: ''
            },
            finalResult: '不通过' // 可从接口返回
        };
    },
    // watch: {
    //     // 当 folderId 变化时，重新加载数据
    //     folderId: {
    //         handler(newVal) {
    //             if (newVal) {
    //                 this.fetchAuditData();
    //             }
    //         },
    //         immediate: true // 组件创建时立即执行一次
    //     }
    // },
    methods: {



        // 调用接口获取审核数据
         fetchAuditData() {
            this.loading = true;
            this.tableData = []; // 清空旧数据
            try {
                getAuditRules({
                    folderId: this.folderId,
                }).then(res => {
                    console.log(res)
                    if(res.code == 200) {
                        this.tableData = res.data;

                        this.finalResult = res.msg || '不通过';
                    }else {
                        this.$message.error(res.msg || '获取数据失败');
                    }
                })
            } catch (error) {
                console.error('获取审核数据失败：', error);
                this.$message.error('请求失败，请检查网络或接口');
            } finally {
                this.loading = false;
            }
        },

        handleView(row) {
            this.$emit('view', row);
        },
        handleEdit(row) {
            this.$emit('edit', row);
        },
        // 格式化审核详情
        formatAuditDetails(details) {
            if (!details) return [];

            // 按分号分割，并去除空项
            const lines = details.split('；').filter(line => line.trim() !== '');

            // 去除每行的首尾空格
            return lines.map(line => line.trim());
        },

        // 根据内容判断行的样式
        getDetailLineClass(line) {
            let classes = 'detail-line';

            if (line.includes('异常') || line.includes('失败') || line.includes('作废') || line.includes('冲红')) {
                classes += ' error-line';
            } else if (line.includes('正常') || line.includes('通过') || line.includes('一致')) {
                classes += ' success-line';
            } else if (line.includes('待') || line.includes('未')) {
                classes += ' warning-line';
            }

            return classes;
        },
    }
};
</script>

<style scoped>
.audit-content {
    max-height: 60vh;
    overflow-y: auto;
}
.final-result {
    font-weight: bold;
}
</style>
